/* This file is generated by a script, to edit it go to 'scripts/generateTimezones.ts' */
export const timezonesByArea = {
  Oceania: [
    'Pacific/Midway',
    'Pacific/Pago_Pago',
    'Pacific/Niue',
    'Pacific/Rarotonga',
    'Pacific/Tahiti',
    'Pacific/Marquesas',
    'Pacific/Gambier',
    'Pacific/Pitcairn',
    'Indian/Christmas',
    'Australia/Perth',
    'Australia/Eucla',
    'Pacific/Palau',
    'Asia/Dili',
    'Australia/Adelaide',
    'Australia/Darwin',
    'Australia/Brisbane',
    'Australia/Sydney',
    'Pacific/Guam',
    'Pacific/Saipan',
    'Pacific/Chuuk',
    'Pacific/Port_Moresby',
    'Australia/Lord_Howe',
    'Pacific/Bougainville',
    'Pacific/Kosrae',
    'Pacific/Noumea',
    'Pacific/Norfolk',
    'Pacific/Guadalcanal',
    'Pacific/Efate',
    'Pacific/Fiji',
    'Pacific/Tarawa',
    'Pacific/Majuro',
    'Pacific/Nauru',
    'Pacific/Auckland',
    'Pacific/Funafuti',
    'Pacific/Wake',
    'Pacific/Wallis',
    'Pacific/Chatham',
    'Pacific/Kanton',
    'Pacific/Apia',
    'Pacific/Fakaofo',
    'Pacific/Tongatapu',
    'Pacific/Kiritimati',
  ],
  'US & Canada': [
    'America/Adak',
    'Pacific/Honolulu',
    'America/Anchorage',
    'America/Los_Angeles',
    'America/Vancouver',
    'America/Edmonton',
    'America/Denver',
    'America/Phoenix',
    'America/Whitehorse',
    'America/Chicago',
    'America/Regina',
    'America/Winnipeg',
    'America/Atikokan',
    'America/New_York',
    'America/Toronto',
    'America/Blanc-Sablon',
    'America/Halifax',
    'America/St_Johns',
  ],
  'North America': [
    'America/Tijuana',
    'America/Hermosillo',
    'America/Ciudad_Juarez',
    'America/Belize',
    'America/Guatemala',
    'America/Managua',
    'America/Mexico_City',
    'America/Matamoros',
    'America/Costa_Rica',
    'America/El_Salvador',
    'America/Tegucigalpa',
    'America/Havana',
    'America/Cancun',
    'America/Cayman',
    'America/Jamaica',
    'America/Nassau',
    'America/Panama',
    'America/Port-au-Prince',
    'America/Grand_Turk',
    'America/St_Kitts',
    'America/Montserrat',
    'America/Barbados',
    'America/Port_of_Spain',
    'America/Martinique',
    'America/St_Lucia',
    'America/St_Barthelemy',
    'Atlantic/Bermuda',
    'America/St_Vincent',
    'America/Kralendijk',
    'America/Guadeloupe',
    'America/Marigot',
    'America/Aruba',
    'America/Lower_Princes',
    'America/Tortola',
    'America/Dominica',
    'America/St_Thomas',
    'America/Grenada',
    'America/Antigua',
    'America/Puerto_Rico',
    'America/Santo_Domingo',
    'America/Anguilla',
    'America/Thule',
    'America/Curacao',
    'America/Miquelon',
    'America/Nuuk',
    'America/Danmarkshavn',
  ],
  'South America': [
    'Pacific/Easter',
    'Pacific/Galapagos',
    'America/Rio_Branco',
    'America/Bogota',
    'America/Guayaquil',
    'America/Lima',
    'America/Manaus',
    'America/La_Paz',
    'America/Santiago',
    'America/Guyana',
    'America/Caracas',
    'America/Argentina/Buenos_Aires',
    'America/Sao_Paulo',
    'America/Punta_Arenas',
    'Atlantic/Stanley',
    'America/Cayenne',
    'America/Asuncion',
    'America/Paramaribo',
    'America/Montevideo',
    'America/Noronha',
  ],
  Antarctica: [
    'Antarctica/Palmer',
    'Atlantic/South_Georgia',
    'Antarctica/Troll',
    'Antarctica/Syowa',
    'Indian/Kerguelen',
    'Antarctica/Mawson',
    'Antarctica/Davis',
    'Antarctica/Casey',
    'Antarctica/DumontDUrville',
    'Antarctica/McMurdo',
  ],
  Europe: [
    'Atlantic/Azores',
    'Europe/Isle_of_Man',
    'Europe/Dublin',
    'Europe/London',
    'Atlantic/Reykjavik',
    'Europe/Jersey',
    'Europe/Guernsey',
    'Atlantic/Canary',
    'Europe/Lisbon',
    'Atlantic/Faroe',
    'Europe/Amsterdam',
    'Europe/Andorra',
    'Europe/Belgrade',
    'Europe/Berlin',
    'Europe/Bratislava',
    'Europe/Brussels',
    'Europe/Budapest',
    'Europe/Copenhagen',
    'Europe/Gibraltar',
    'Europe/Ljubljana',
    'Arctic/Longyearbyen',
    'Europe/Luxembourg',
    'Europe/Madrid',
    'Europe/Monaco',
    'Europe/Oslo',
    'Europe/Paris',
    'Europe/Podgorica',
    'Europe/Prague',
    'Europe/Rome',
    'Europe/San_Marino',
    'Europe/Malta',
    'Europe/Sarajevo',
    'Europe/Skopje',
    'Europe/Stockholm',
    'Europe/Tirane',
    'Europe/Vaduz',
    'Europe/Vatican',
    'Europe/Vienna',
    'Europe/Warsaw',
    'Europe/Zagreb',
    'Europe/Zurich',
    'Europe/Athens',
    'Europe/Bucharest',
    'Europe/Chisinau',
    'Europe/Helsinki',
    'Europe/Kaliningrad',
    'Europe/Kyiv',
    'Europe/Mariehamn',
    'Asia/Nicosia',
    'Europe/Riga',
    'Europe/Sofia',
    'Europe/Tallinn',
    'Europe/Vilnius',
    'Europe/Minsk',
    'Europe/Moscow',
    'Europe/Simferopol',
    'Europe/Samara',
    'Asia/Yekaterinburg',
    'Asia/Omsk',
    'Asia/Novosibirsk',
    'Asia/Irkutsk',
    'Asia/Chita',
    'Asia/Vladivostok',
    'Asia/Sakhalin',
    'Asia/Kamchatka',
  ],
  Africa: [
    'Atlantic/Cape_Verde',
    'Africa/Abidjan',
    'Africa/Bamako',
    'Africa/Bissau',
    'Africa/Conakry',
    'Africa/Dakar',
    'Africa/Freetown',
    'Atlantic/St_Helena',
    'Africa/Accra',
    'Africa/Lome',
    'Africa/Monrovia',
    'Africa/Nouakchott',
    'Africa/Ouagadougou',
    'Africa/Banjul',
    'Africa/Sao_Tome',
    'Africa/Casablanca',
    'Africa/El_Aaiun',
    'Africa/Windhoek',
    'Africa/Algiers',
    'Africa/Tunis',
    'Africa/Bangui',
    'Africa/Malabo',
    'Africa/Brazzaville',
    'Africa/Porto-Novo',
    'Africa/Douala',
    'Africa/Kinshasa',
    'Africa/Lagos',
    'Africa/Libreville',
    'Africa/Luanda',
    'Africa/Ndjamena',
    'Africa/Niamey',
    'Africa/Bujumbura',
    'Africa/Gaborone',
    'Africa/Harare',
    'Africa/Juba',
    'Africa/Khartoum',
    'Africa/Kigali',
    'Africa/Blantyre',
    'Africa/Lubumbashi',
    'Africa/Lusaka',
    'Africa/Maputo',
    'Africa/Cairo',
    'Africa/Tripoli',
    'Africa/Johannesburg',
    'Africa/Mbabane',
    'Africa/Maseru',
    'Africa/Addis_Ababa',
    'Indian/Antananarivo',
    'Africa/Asmara',
    'Africa/Dar_es_Salaam',
    'Africa/Djibouti',
    'Africa/Kampala',
    'Indian/Mayotte',
    'Africa/Mogadishu',
    'Indian/Comoro',
    'Africa/Nairobi',
    'Indian/Mauritius',
    'Indian/Reunion',
    'Indian/Mahe',
  ],
  Asia: [
    'Asia/Beirut',
    'Asia/Hebron',
    'Asia/Jerusalem',
    'Asia/Kuwait',
    'Asia/Bahrain',
    'Asia/Baghdad',
    'Asia/Qatar',
    'Asia/Riyadh',
    'Asia/Aden',
    'Asia/Amman',
    'Asia/Damascus',
    'Europe/Istanbul',
    'Asia/Tehran',
    'Asia/Yerevan',
    'Asia/Baku',
    'Asia/Tbilisi',
    'Asia/Dubai',
    'Asia/Muscat',
    'Asia/Kabul',
    'Asia/Almaty',
    'Indian/Maldives',
    'Asia/Karachi',
    'Asia/Dushanbe',
    'Asia/Ashgabat',
    'Asia/Tashkent',
    'Asia/Colombo',
    'Asia/Kolkata',
    'Asia/Kathmandu',
    'Asia/Dhaka',
    'Asia/Thimphu',
    'Asia/Urumqi',
    'Indian/Chagos',
    'Asia/Bishkek',
    'Indian/Cocos',
    'Asia/Yangon',
    'Asia/Hovd',
    'Asia/Bangkok',
    'Asia/Ho_Chi_Minh',
    'Asia/Phnom_Penh',
    'Asia/Vientiane',
    'Asia/Jakarta',
    'Asia/Brunei',
    'Asia/Makassar',
    'Asia/Macau',
    'Asia/Shanghai',
    'Asia/Hong_Kong',
    'Asia/Kuala_Lumpur',
    'Asia/Manila',
    'Asia/Singapore',
    'Asia/Taipei',
    'Asia/Ulaanbaatar',
    'Asia/Jayapura',
    'Asia/Tokyo',
    'Asia/Pyongyang',
    'Asia/Seoul',
  ],
  UTC: ['UTC'],
} as const
